import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

const ImageUploadBox = ({ 
  label, 
  preview, 
  setPreview, 
  onFileSelect, 
  width, 
  height, 
  required = false,
  name,
  error,
  setError
}) => {
  const fileInputRef = useRef();

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // --- Validation ---
    if (!file.type.startsWith("image/")) {
      setError((prev)=>({...prev,[name]:"Only image files are allowed."}));
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      setError((prev)=>({...prev,[name]:"File size must not exceed 5 MB."}));
      return;
    }

    // --- Success ---
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    onFileSelect(file);
    setError(prev => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setPreview(null);
    onFileSelect(null);
    fileInputRef.current.value = null;
    if (required) {
      setError((prev)=>({...prev,[name]:`${name == 'mobileImage' ? 'Mobile' : 'Web'} image is required.`}));
    }
  };

  return (
    <div className="mb-3">
      {label && <Form.Label>{label}</Form.Label>}
      <div
        onClick={handleClick}
        style={{
          width,
          height,
          border: error[name] ? "2px dashed red" : "2px dashed #ccc",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          overflow: "hidden",
          background: "#f9f9f9",
          position: "relative",
        }}
      >
        {preview ? (
          <>
            <img
              src={preview}
              alt="preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            <button
              type="button"
              onClick={handleRemove}
              style={{
                position: "absolute",
                top: "5px",
                right: "5px",
                background: "rgba(0,0,0,0.6)",
                border: "none",
                borderRadius: "50%",
                color: "#fff",
                width: "24px",
                height: "24px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ✕
            </button>
          </>
        ) : (
          <span style={{ color: "#888" }}>+ Add Image</span>
        )}
      </div>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleChange}
      />
      {error[name] && (
        <div style={{ color: "red", marginTop: "5px", fontSize: "0.875rem" }}>
          {error[name]}
        </div>
      )}
    </div> 
  );
};

export default ImageUploadBox;
